export default __webpack_public_path__ + "static/media/Aura-Egg__46.883f23f7.png";